export const prefixActionTypes = (types, prefix) =>
    prefix
        ? Object.entries(types).reduce((prefixedTypes, [key, type]) => {
              prefixedTypes[key] = `${prefix}/${type}`;
              return prefixedTypes;
          }, {})
        : types;

export default prefixActionTypes;
